export default __webpack_public_path__ + "static/media/iconLogo.e965ea1c.svg";